// format the distance to km if the distance is greater than 1000m
export const formatDistance = (distance: number): string => {
  if (distance < 1000) return `${distance}m`
  return `${Math.round(distance / 1000)}km`
}

export default formatDistance
